﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ErrorPageForbidden_1 = require("./ErrorPageForbidden");
exports.ErrorPageForbidden = ErrorPageForbidden_1.default;
var ErrorPageInternalError_1 = require("./ErrorPageInternalError");
exports.ErrorPageInternalError = ErrorPageInternalError_1.default;
//# sourceMappingURL=index.js.map